import {Chip} from '@dropbox/dig-components/chip';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Stack} from '@dropbox/dig-foundations';
import {PlugMini} from '@dropbox/dig-illustrations';
import {Title} from 'components/DSYS/Title';
import {t} from 'i18next';
import {EXTERNAL_CLIENT_GUIDES} from 'pages/mcpClientGuides';

import {ClientLogo} from './workstreamMcpSteps';

export const WorkstreamMcpAppsIntro = ({
  onMcpConnect,
}: {
  onMcpConnect: (clientId: string) => void;
}) => (
  <>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{flex: '1 1 0%'}}
    >
      <Stack gap="8" style={{textAlign: 'center', maxWidth: 460}}>
        <PlugMini width="40" altText={t('workstream_mcp_apps_title')} />
        <Title size={16}>{t('workstream_mcp_apps_title')}</Title>
        <Text color="subtle" className={atoms({display: 'block'})}>
          {t('workstream_mcp_apps_subtitle')}
        </Text>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          style={{gap: 10}}
          paddingTop="8"
        >
          {EXTERNAL_CLIENT_GUIDES.map((guide) => (
            <Chip key={guide.id} type="button" onClick={() => onMcpConnect(guide.id)}>
              <Chip.IconAccessory>
                <ClientLogo guide={guide} />
              </Chip.IconAccessory>
              <Chip.Content>{guide.name}</Chip.Content>
            </Chip>
          ))}
        </Box>
      </Stack>
    </Box>

    <Box
      display="flex"
      alignItems="center"
      paddingY="12"
      style={{gap: 12, width: '100%', flexShrink: 0}}
    >
      <Box borderTop="Solid" borderColor="Border Subtle" borderWidth="1" style={{flex: '1 1 0%'}} />
      <Text size="small" color="subtle">
        {t('workstream_mcp_or')}
      </Text>
      <Box borderTop="Solid" borderColor="Border Subtle" borderWidth="1" style={{flex: '1 1 0%'}} />
    </Box>
  </>
);
